<div class="content-container">
  <div class="picture-container">
    <div class="container">
      <mat-checkbox [ngModelOptions]="{standalone: true}"
        [ngModel]="personsPerSquareMeterComponent?.overrideDefaultValue"
        (ngModelChange)="personsPerSquareMeterComponent.overrideDefaultValue = $event" class="margin-right form-field">
        Override default value
      </mat-checkbox>
      <mat-form-field appearance="outline" class="form-field"
        *ngIf="personsPerSquareMeterComponent.overrideDefaultValue">
        <mat-label>Number of people per m<sup>2</sup></mat-label>
        <input matInput type="number" step="0.5" [ngModel]="personsPerSquareMeterComponent?.amountOfPeople"
          (ngModelChange)="personsPerSquareMeterComponent.amountOfPeople = $event" autocomplete="off">
      </mat-form-field>
      <mat-form-field *ngIf="showFeatureBycicleAmount" appearance="outline" class="form-field">
        <mat-label>Number of bycicles</mat-label>
        <input matInput type="number" [ngModel]="multiPurposeAreaComponent?.bycicleAmount"
          (ngModelChange)="multiPurposeAreaComponent.bycicleAmount = $event" autocomplete="off" (keypress)="integerOnly($event)">
      </mat-form-field>
      <mat-form-field *ngIf="showFeatureSkiAmount" appearance="outline" class="form-field">
        <mat-label>Number of skis</mat-label>
        <input matInput type="number" [ngModel]="multiPurposeAreaComponent?.skiAmount"
          (ngModelChange)="multiPurposeAreaComponent.skiAmount = $event" autocomplete="off" (keypress)="integerOnly($event)">
      </mat-form-field>
      <mat-form-field *ngIf="showFeatureStrollerAmount" appearance="outline" class="form-field">
        <mat-label>Number of strollers</mat-label>
        <input matInput type="number" [ngModel]="multiPurposeAreaComponent?.strollerAmount"
          (ngModelChange)="multiPurposeAreaComponent.strollerAmount = $event" autocomplete="off" (keypress)="integerOnly($event)">
      </mat-form-field>
    </div>
  </div>
</div>